(function() {
    'use strict';

    angular
        .module('taskApp',['corePRUGAGreatApp'])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();